import {
  createPurchaseFlowNonTripOfferBooking,
  createPurchaseFlowTripOfferBooking,
  getPurchaseFlowBookingById,
} from '@/features/purchase/purchaseActions';
import { useSearchWidget } from '@/hooks/useSearchWidget';
import { TransText } from '@/i18n/trans/text';
import { useDispatch } from '@/store/utils';
import type { ApiErrorResponse } from '@/types/api';
import type { CreateBookingResponseDTO } from '@/types/dto/agent';
import { showErrorToast } from '@/utils/errorToast';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useBookingCreation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentSearchFormValues } = useSearchWidget();

  const fetchBookingDetailsById = useCallback(
    async (createBookingResponse: CreateBookingResponseDTO) => {
      const id = createBookingResponse.booking?.id;

      if (id) {
        await dispatch(getPurchaseFlowBookingById(id)).unwrap();

        navigate('/purchase/checkout');
      }
    },
    [dispatch, navigate]
  );

  const handleCreatingAndFetchingTripOfferBooking = useCallback(async () => {
    try {
      const booking = await dispatch(
        createPurchaseFlowTripOfferBooking(
          currentSearchFormValues?.passengers ?? []
        )
      ).unwrap();

      await fetchBookingDetailsById(booking);
    } catch (e) {
      showErrorToast(
        <TransText i18nKey="failedToCreateBooking" />,
        e as ApiErrorResponse
      );
    }
  }, [currentSearchFormValues?.passengers, dispatch, fetchBookingDetailsById]);

  const handleCreatingAndFetchingNonTripOfferBooking = useCallback(async () => {
    try {
      const booking = await dispatch(
        createPurchaseFlowNonTripOfferBooking(
          currentSearchFormValues?.passengers ?? []
        )
      ).unwrap();

      await fetchBookingDetailsById(booking);
    } catch (e) {
      showErrorToast(
        <TransText i18nKey="failedToCreateBooking" />,
        e as ApiErrorResponse
      );
    }
  }, [currentSearchFormValues?.passengers, dispatch, fetchBookingDetailsById]);

  return {
    handleCreatingAndFetchingTripOfferBooking,
    handleCreatingAndFetchingNonTripOfferBooking,
  };
};
